import { NgModule } from '@angular/core';
import { AppCommonModule } from '../app-common.module';
import { ContactUsComponent } from '../contact-us/contact-us.component';
import { MobileUploadInvoicesComponent } from '../invoices/upload-invoices/mobile-upload-invoices/mobile-upload-invoices.component';
import { FactoringRoutingModule } from './factoring-routing.module';

@NgModule({
    imports: [FactoringRoutingModule, AppCommonModule],
    declarations: [ContactUsComponent, MobileUploadInvoicesComponent]
})
export class FactoringModule {}
